import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { GStatic } from '../../../services/GStatic';
import { GAnalyticsService } from '../../../services/g-analytics.service';
import { ActiveMember } from '../../../models/members.model';
import moment from 'moment/moment';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ObservationsService } from '../../../services/Observations/observations.service';
import { ProjectsService } from '../../../services/projects.service';
import { ObservationDetailsComponent } from '../../../modules/observations-manager/observation-details/observation-details.component';
import { ToastrService } from 'ngx-toastr';
import { GlobalService } from '../../../services/global.service';
import { TranslocoService } from '@ngneat/transloco';
import { Project360Service } from '../../../modules/p-dashboard/project360.service';
import { PanosService } from '../../../modules/project/panos.service';
import { DemoProjectService } from '../../../modules/demo-viewer/demo-project.service';
import { parseInt } from 'lodash-es';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from '../confirm-dialog/confirm-dialog.component';
import { ViewerModeService } from '../../../modules/demo-viewer/viewer-mode.service';

import { CustomFieldRendererService } from '../../../services/custom-field-renderer.service';
import { CustomField } from '../../../models/custom-fields.model';
import { ObservationCustomFieldsService } from '../../../services/observation-custom-fields.service';
import Quill from 'quill';
import { UserService } from 'app/core/user/user.service';
import { appendObservationHashtagsToFormData } from '../../utils/observation-form.utils';
import { ObservationCategory } from '../../../models/observations.model';

@Component({
  selector: 'app-add-observation-dialog',
  templateUrl: './add-observation-dialog.component.html',
  styleUrls: ['./add-observation-dialog.component.scss'],
})
export class AddObservationDialogComponent implements OnInit, OnDestroy {
  observationForm!: UntypedFormGroup;
  isLoading = false;
  screenShotImage: any;
  currentShape: string = 'Pen';
  position = { x: 0, y: 0 };
  imageSrc = '';
  isScreenshotLoading = true;

  fileOptions = {
    maxFilesLimit: 10,
    maxFileSize: 200,
    allowedExtensions: [
      'pdf',
      'jpg',
      'jpeg',
      'png',
      'mp4',
      'xlsx',
      'xls',
      'doc',
      'docx',
      'ppt',
      'pptx',
    ],
  };

  colorArray = [
    {
      name: 'black',
      color: 'black',
    },
    {
      name: 'red',
      color: 'red',
    },
    {
      name: 'green',
      color: 'green',
    },
  ];
  defaultScrnShotState = false;

  ctx: CanvasRenderingContext2D;
  paintSizes = ['1x', '2x', '3x'];
  @ViewChild('screenshot') screenshot: any;
  @ViewChild('screenshot2') myCanvas: any;
  shapes = ['Pen', 'Square', 'Circle', 'Triangle', 'Arrow'];
  private startX: number;
  private startY: number;
  private canvas: HTMLCanvasElement;
  private isDrawing: boolean = false;
  attachments = [];
  observationHashtags: string[] = [];
  observationCategories: ObservationCategory[] = [];
  observationChildCategories: ObservationCategory[] = [];
  projectActiveMembers: ActiveMember[];
  selectedType: boolean = false;
  currentDueDate = new UntypedFormControl();
  formattedDate: string = '';
  @Input() minDate: Date;
  observationSignificances: any[] = [];
  observationTypes = [];
  observationCodes = [];
  configurableFields: any[] = [];
  searchControl = new FormControl('');
  filteredUsers: ActiveMember[];
  protected _onDestroy = new Subject<void>();

  // Custom Fields Properties
  customFields$ = new BehaviorSubject<CustomField[]>([]);
  isLoadingCustomFields$ = new BehaviorSubject<boolean>(false);
  private observationCategoriesRequestId = 0;

  nwc_client: boolean = false;

  get maxQuillEditorsLength(): number {
    return this.nwc_client ? 4000 : 1000;
  }

  // Get title max length based on client type
  get titleMaxLength(): number {
    return this.nwc_client ? 128 : 200;
  }

  private isEditorReady(editor: Quill): boolean {
    return editor && typeof editor.getText === 'function' && editor.getText;
  }

  private isComponentReady(): boolean {
    return this.observationForm && !this.isLoading;
  }
  quillConfig = {
    toolbar: [
      ['bold'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      // [{ align: [] }],
      // [{ direction: 'rtl' }],
      ['clean'],
    ],
  };
  // Add truncation management properties
  shouldTruncateAfterPaste: boolean = false;
  pendingTruncationLength: number = 0;

  descriptionEditor: Quill;
  recommendedActionEditor: Quill;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private observationsService: ObservationsService,
    private projectService: ProjectsService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ObservationDetailsComponent>,
    private fb: UntypedFormBuilder,
    private _toaster: ToastrService,
    private globalService: GlobalService,
    public demoProjectService: DemoProjectService,
    private translocoService: TranslocoService,
    public _project: Project360Service,
    public _pano: PanosService,
    private googleServices: GAnalyticsService,
    private viewerMode: ViewerModeService,

    private customFieldRenderer: CustomFieldRendererService,
    private observationCustomFields: ObservationCustomFieldsService,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
  ) {
    // Detect backdrop click
    // dialogRef.backdropClick().subscribe(() => {
    //   console.log('Click registered');
    //   this.openConfirmationDialog();
    // });
    // Detect Escape key press
    // dialogRef.keydownEvents().subscribe((event) => {
    //   if (event.key === 'Escape') {
    //     console.log('Esc registered');
    //     this.openConfirmationDialog();
    //   }
    // });
  }

  async ngOnInit(): Promise<void> {
    const currentUserPromise = this.userService.getCurrentUser();

    this.initForm();

    const currentUser = await currentUserPromise;
    this.nwc_client = currentUser.custom_fields_enabled;
    this.applyNwcClientMode();

    await this.getObservationSignificancesAndTypes();
    await this.getProjectActiveMembers();
    this.getBinaryScreenShotFile();
    this.imageSrc = this.data.observationScreenshot;

    // Initialize custom fields properties
    const customFieldsProps = this.observationCustomFields.initializeCustomFieldsProperties();
    this.customFields$ = customFieldsProps.customFields$;
    this.isLoadingCustomFields$ = customFieldsProps.isLoadingCustomFields$;

    // Setup custom fields for the default observation type
    this.setupCustomFields();

    //Add search to users list
    this.searchControl.valueChanges
      .pipe(debounceTime(700), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (val.toString().length > 0) {
          this.filteredUsers = this.projectActiveMembers.filter(
            (user) =>
              user.name.toLowerCase().includes(val.toLowerCase()) ||
              user.email.toLowerCase().includes(val.toLowerCase()),
          );
        } else if (val.toString().length === 0) {
          this.filteredUsers = [...this.projectActiveMembers];
        }
      });
  }

  initForm(): void {
    this._setMinDate();
    const formControls: any = {
      project_id: [this.data.project_id, Validators.required],
      report_id: [this.data.report_id, Validators.required],
      floor_id: [this.data.floor_id, Validators.required],
      point_id: [this.data.point_id, Validators.required],
      location_x: [this.data.location_x, Validators.required],
      location_y: [this.data.location_y, Validators.required],
      title: [null, Validators.required],
      description: [null],
      recommended_corrective_action: [null],
      screen_shot: [null],
      categories: [this.nwc_client ? null : [], Validators.required],
      child_categories: [this.nwc_client ? null : []],
      users: [null, Validators.required],
    };

    // Conditionally add fields based on configurable_fields visibility
    if (this.isFieldVisible('type')) {
      formControls.type = ['general', Validators.required];
    }
    if (this.isFieldVisible('privacy')) {
      formControls.privacy = ['public', Validators.required];
    }
    if (this.isFieldVisible('significance')) {
      formControls.significance = [null];
    }
    if (this.isFieldVisible('due_date')) {
      formControls.due_date = [null];
    }
    if (this.isFieldVisible('code')) {
      formControls.code = ['none']; //OBS code with default value N/A => none
    }

    this.observationForm = this.fb.group(formControls);
  }

  /**
   * Check if a field is visible based on configurable_fields
   * Returns true if field is visible, false if hidden or not configured
   */
  isFieldVisible(fieldName: string): boolean {
    if (!this.configurableFields || this.configurableFields.length === 0) {
      // If no configurable_fields, show all fields by default
      return true;
    }
    const fieldConfig = this.configurableFields.find((field) => field.attribute === fieldName);
    // If field is not in configurable_fields, show it by default
    // If field is in configurable_fields, use its visible property
    return fieldConfig ? fieldConfig.visible !== false : true;
  }

  /**
   * Remove hidden fields from the form based on configurable_fields
   */
  removeHiddenFieldsFromForm(): void {
    if (!this.observationForm || !this.configurableFields || this.configurableFields.length === 0) {
      return;
    }

    this.configurableFields.forEach((fieldConfig) => {
      if (fieldConfig.visible === false && this.observationForm.get(fieldConfig.attribute)) {
        this.observationForm.removeControl(fieldConfig.attribute);
      }
    });
  }

  private applyNwcClientMode(): void {
    const categoriesControl = this.observationForm.get('categories');
    const childCategoriesControl = this.observationForm.get('child_categories');

    if (!categoriesControl || !childCategoriesControl) {
      return;
    }

    if (this.nwc_client) {
      categoriesControl.setValue(null, { emitEvent: false });
      childCategoriesControl.setValue(null, { emitEvent: false });
    } else {
      if (categoriesControl.value === null) {
        categoriesControl.setValue([], { emitEvent: false });
      }
      if (childCategoriesControl.value === null) {
        childCategoriesControl.setValue([], { emitEvent: false });
      }
    }

    this.observationForm.updateValueAndValidity({ emitEvent: false });
  }

  private _setMinDate() {
    this.minDate = new Date();
    this.minDate.setUTCHours(0, 0, 0, 0);
  }

  async getObservationCategories(): Promise<void> {
    const currentObservationType = this.observationForm.get('type')?.value;
    const requestId = ++this.observationCategoriesRequestId;

    try {
      const res: any = await firstValueFrom(
        this.observationsService.observationCategories(currentObservationType),
      );
      if (
        requestId !== this.observationCategoriesRequestId ||
        currentObservationType !== this.observationForm.get('type')?.value
      ) {
        return;
      }

      this.observationCategories = this.observationCustomFields.normalizeObservationCategories(
        res?.observation_categories,
      );
      this.observationCustomFields.syncSelectedObservationCategories(
        this.observationForm,
        this.observationCategories,
        this.nwc_client,
      );

      // Update child categories based on current selected category
      this.updateChildCategories();
    } catch (error) {
      console.error('Error fetching observation categories:', error);
      //todo: @medhat, should we show an error to the user?
    }
  }

  updateChildCategories(): void {
    const selectedCategories = this.observationForm.get('categories')?.value;
    this.observationChildCategories = this.observationCustomFields.getObservationChildCategories(
      this.observationCategories,
      selectedCategories,
      this.nwc_client,
    );
  }

  onCategorySelectionChange(): void {
    this.observationCustomFields.resetObservationCategoryState(
      this.observationForm,
      this.nwc_client,
    );
    this.updateChildCategories();
  }

  shouldShowSubcategoryField(): boolean {
    return this.observationCustomFields.shouldShowObservationSubcategoryField(
      this.observationForm,
      this.observationChildCategories,
      this.nwc_client,
      this.observationCategories,
    );
  }

  async getProjectActiveMembers(): Promise<void> {
    try {
      const res = await this.observationsService
        .projectActiveMembers(this.demoProjectService.projectId)
        .toPromise();
      this.projectActiveMembers = res.data;
      this.filteredUsers = this.projectActiveMembers;
    } catch (error) {
      this._toaster.error(
        error || this.translocoService.translate('Something went wrong, please try again.'),
      );
    }
  }

  setPosition(e: MouseEvent | TouchEvent): void {
    let x, y;
    if (e instanceof MouseEvent) {
      x = e.offsetX;
      y = e.offsetY;
    } else if (e instanceof TouchEvent) {
      x = e.touches[0].clientX - this.myCanvas.nativeElement.offsetLeft;
      y = e.touches[0].clientY - this.myCanvas.nativeElement.offsetTop;
    }
    this.position.x = x;
    this.position.y = y;
  }

  onCanvasMouseDown(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.isDrawing = true;
    const { offsetX, offsetY } = this.getCoordinates(event);
    this.startX = offsetX;
    this.startY = offsetY;
  }

  onCanvasMouseMove(event: MouseEvent | TouchEvent) {
    if (!this.isDrawing) return;
    const { offsetX, offsetY } = this.getCoordinates(event);
    const width = offsetX - this.startX;
    const height = offsetY - this.startY;

    this.clearCanvas();
    if (this.currentShape === 'Square') {
      this.drawSquare(this.startX, this.startY, width, height);
    }
    if (this.currentShape === 'Circle') {
      const centerX = this.startX + width / 2;
      const centerY = this.startY + height / 2;
      const radiusX = Math.abs(width / 2);
      const radiusY = Math.abs(height / 2);

      this.drawEllipse(centerX, centerY, radiusX, radiusY);
    }
    if (this.currentShape === 'Triangle') {
      const x1 = this.startX + width / 2;
      const y1 = this.startY;
      const x2 = this.startX;
      const y2 = this.startY + width;
      const x3 = this.startX + width;
      const y3 = this.startY + width;

      this.drawTriangle(x1, y1, x2, y2, x3, y3);
    }
    if (this.currentShape === 'Arrow') {
      const arrowSize = 10;
      this.drawArrow(
        this.startX,
        this.startY,
        this.startX + width,
        this.startY + height,
        arrowSize,
      );
    }
  }
  drawTriangle(x1, y1, x2, y2, x3, y3) {
    // Save the current context state
    this.ctx.save();

    // Set the border style

    // Begin path
    this.ctx.beginPath();

    // Move to the first vertex
    this.ctx.moveTo(x1, y1);

    // Draw lines to the other two vertices
    this.ctx.lineTo(x2, y2);
    this.ctx.lineTo(x3, y3);

    // Close the path by drawing a line back to the first vertex
    this.ctx.closePath();

    // Draw the border
    this.ctx.stroke();

    // Restore the context state
    this.ctx.restore();
  }

  onCanvasMouseUp(event: MouseEvent | TouchEvent) {
    this.isDrawing = false;
    const { offsetX, offsetY } = this.getCoordinates(event);
    const width = offsetX - this.startX;
    const height = offsetY - this.startY;

    if (this.currentShape === 'Square') {
      this.drawSquare(this.startX, this.startY, width, height);
    }
    if (this.currentShape === 'Circle') {
      const centerX = this.startX + width / 2;
      const centerY = this.startY + height / 2;
      const radiusX = Math.abs(width / 2);
      const radiusY = Math.abs(height / 2);

      this.drawEllipse(centerX, centerY, radiusX, radiusY);
    }
    if (this.currentShape === 'Triangle') {
      const x1 = this.startX + width / 2;
      const y1 = this.startY;
      const x2 = this.startX;
      const y2 = this.startY + width;
      const x3 = this.startX + width;
      const y3 = this.startY + width;

      this.drawTriangle(x1, y1, x2, y2, x3, y3);
    }
    if (this.currentShape === 'Arrow') {
      const arrowSize = 10;
      this.drawArrow(
        this.startX,
        this.startY,
        this.startX + width,
        this.startY + height,
        arrowSize,
      );
    }
    this.saveImg(event);
  }

  onCanvasTouchStart(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.onCanvasMouseDown(event);
  }

  onCanvasTouchMove(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.onCanvasMouseMove(event);
  }

  onCanvasTouchEnd(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.onCanvasMouseUp(event);
    this.saveImg(event);
  }

  getCoordinates(event: MouseEvent | TouchEvent) {
    let offsetX: number;
    let offsetY: number;

    // Check if it's a touch event
    if ('touches' in event) {
      const touch = (event as TouchEvent).touches[0];
      offsetX = touch.clientX - this.canvas.offsetLeft;
      offsetY = touch.clientY - this.canvas.offsetTop;
    } else {
      offsetX = (event as MouseEvent).offsetX;
      offsetY = (event as MouseEvent).offsetY;
    }

    return { offsetX, offsetY };
  }

  drawArrow(startX, startY, endX, endY, arrowSize) {
    // Save the current context state
    this.ctx.save();

    // Begin path
    this.ctx.beginPath();

    // Draw the line
    this.ctx.moveTo(startX, startY);
    this.ctx.lineTo(endX, endY);

    // Calculate the angle of the line
    const angle = Math.atan2(endY - startY, endX - startX);

    // Calculate the coordinates of the arrow head
    const arrowX1 = endX - arrowSize * Math.cos(angle - Math.PI / 6);
    const arrowY1 = endY - arrowSize * Math.sin(angle - Math.PI / 6);
    const arrowX2 = endX - arrowSize * Math.cos(angle + Math.PI / 6);
    const arrowY2 = endY - arrowSize * Math.sin(angle + Math.PI / 6);

    // Draw the arrow head
    this.ctx.moveTo(endX, endY);
    this.ctx.lineTo(arrowX1, arrowY1);
    this.ctx.moveTo(endX, endY);
    this.ctx.lineTo(arrowX2, arrowY2);

    // Draw the line and arrow head
    this.ctx.stroke();

    // Restore the context state
    this.ctx.restore();
  }

  drawEllipse(centerX, centerY, radiusX, radiusY) {
    // Save the current context state
    this.ctx.save();

    // Begin path
    this.ctx.beginPath();

    // Calculate the starting angle and ending angle for a full ellipse
    const startAngle = 0;
    const endAngle = 2 * Math.PI;

    // Draw the ellipse
    this.ctx.ellipse(centerX, centerY, radiusX, radiusY, 0, startAngle, endAngle);

    // Draw the border
    this.ctx.stroke();

    // Restore the context state
    this.ctx.restore();
  }

  drawSquare(x: number, y: number, width: number, height: number) {
    this.ctx.strokeRect(x, y, width, height);
  }

  clearCanvas() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  draw(e: MouseEvent | TouchEvent, color?: string): void {
    // mouse left button or touch must be pressed
    if (
      (e instanceof MouseEvent && e.buttons !== 1) ||
      (e instanceof TouchEvent && e.touches.length !== 1)
    ) {
      return;
    }

    this.ctx.beginPath(); // begin

    this.ctx.lineCap = 'round';

    let x, y;
    if (e instanceof MouseEvent) {
      x = e.clientX - this.myCanvas.nativeElement.offsetLeft;
      y = e.clientY - this.myCanvas.nativeElement.offsetTop;
    } else if (e instanceof TouchEvent) {
      x = e.touches[0].clientX - this.myCanvas.nativeElement.offsetLeft;
      y = e.touches[0].clientY - this.myCanvas.nativeElement.offsetTop;
    }

    this.ctx.moveTo(this.position.x, this.position.y); // from
    this.position.x = x;
    this.position.y = y;
    this.ctx.lineTo(this.position.x, this.position.y); // to

    this.ctx.stroke(); // draw it
  }
  saveImg($event: MouseEvent | TouchEvent): void {
    this.defaultScrnShotState = true;
    const dataURL = this.myCanvas.nativeElement.toDataURL('image/png', 1000);
    this.screenShotImage = this.projectService.dataURItoBlob(dataURL, 'screenshot');
  }

  changeColor(value): void {
    this.googleServices.setEvent(
      'AddNewObservation_PenChangeColor_project',
      'Viewer Interactivity',
    );
    GStatic.log('color' + value);
    this.ctx.strokeStyle = value;
  }
  getBinaryScreenShotFile(): void {
    this.googleServices.setEvent(
      'AddNewObservation_ResetScreenShot_project',
      'Viewer Interactivity',
    );

    const canvasEl = this.myCanvas?.nativeElement;
    if (!canvasEl) {
      this.isScreenshotLoading = true;
      setTimeout(() => this.getBinaryScreenShotFile(), 0);
      return;
    }

    // Directly using the imageSrc string, no need to take a screenshot.
    const base64 = this.data.observationScreenshot; // Assuming this.imageSrc already contains the base64 or image URL.

    if (!base64) {
      this.isScreenshotLoading = false;
      return;
    }

    this.isScreenshotLoading = true;
    if (base64) {
      this.ctx = canvasEl.getContext('2d');
      const image = new Image();

      image.onload = () => {
        // Adjust canvas size based on the image dimensions
        canvasEl.height = (image.height * canvasEl.offsetWidth) / image.width;

        // Draw the image onto the canvas
        this.ctx.drawImage(image, 0, 0, canvasEl.width, canvasEl.height);
        this.isScreenshotLoading = false;
        this.cdr.markForCheck();
      };

      image.onerror = () => {
        this.isScreenshotLoading = false;
        this.cdr.markForCheck();
      };

      image.src = base64; // Set the image source directly from the available string.
    }
  }

  changeSize(value): void {
    this.googleServices.setEvent('AddNewObservation_PenChangeSize_project', 'Viewer Interactivity');
    value = parseInt(value.substring(0, 1));
    this.ctx.lineWidth = value;
  }
  changeShape(shape: string) {
    this.currentShape = shape;
  }
  setGoogleEvent(eventAction: string): void {
    this.googleServices.setEvent(eventAction, 'Viewer Interactivity');
  }

  onObservationHashtagsChange(tags: string[]): void {
    this.observationHashtags = tags;
  }
  checkMobile() {
    let ua = window.navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)
    )
      return true;
    else return false;
  }
  getDate(value: any): void {
    this.googleServices.setEvent('AddNewObservation_DueDate_project', 'Viewer Interactivity');

    const currentUserTime = moment(value).unix();
    const currentTimePlusHour = moment().add(0.99, 'hours').unix();
    if (currentUserTime <= currentTimePlusHour) {
      this._toaster.warning(
        this.translocoService.translate(
          'Due time must be at least more than one hour from current time!',
        ),
      );
      this.currentDueDate = new UntypedFormControl('');
    } else {
      //correcting time zone to Riyadh
      this.formattedDate = this.globalService.correctingTimeZone(value);
    }
  }
  resetPicker() {
    this.currentDueDate = new UntypedFormControl(null);
    this.formattedDate = '';
  }

  getType(type): void {
    GStatic.log('type: ' + type.value);

    if (type.value !== 'note') {
      this.googleServices.setEvent(
        'AddNewObservation_SelectObservationType_project',
        'Viewer Interactivity',
      );
      this.selectedType = true;
    } else {
      this.googleServices.setEvent(
        'AddNewObservation_SelectNoteType_project',
        'Viewer Interactivity',
      );
      this.formattedDate = '';
      this.selectedType = false;
    }

    this.observationCustomFields.resetObservationCategoryState(
      this.observationForm,
      this.nwc_client,
    );
    this.observationChildCategories = [];

    // Handle observation type change (custom fields and categories)
    this.observationCustomFields.handleObservationTypeChange(
      type.value,
      this.observationForm,
      this.customFields$,
      this.isLoadingCustomFields$,
    );

    // Load categories for the selected observation type
    this.getObservationCategories();
  }

  /**
   * Setup custom fields for the current observation type
   */
  setupCustomFields(): void {
    this.observationCustomFields
      .setupCustomFields(
        this.observationForm.get('type')?.value,
        this.observationForm,
        this.customFields$,
        this.isLoadingCustomFields$,
      )
      .subscribe();
  }

  /**
   * Get custom field values from the form
   */
  getCustomFieldValues(): any {
    return this.observationCustomFields.getCustomFieldValues(
      this.observationForm,
      this.customFields$.value,
    );
  }

  isDateValue(value: any): boolean {
    return this.observationCustomFields.isDateValue(value);
  }

  onSubmit(isDraft: boolean): void {
    if (!this.observationForm.valid && !isDraft) {
      return;
    }
    this.isLoading = true;
    const FORM_BODY = new FormData();
    // Process form data including custom fields
    this.observationCustomFields.processFormDataForSubmission(
      this.observationForm,
      FORM_BODY,
      this.customFields$.value,
    );
    if (!this.defaultScrnShotState) {
      const dataURL = this.imageSrc;
      this.screenShotImage = this.projectService.dataURItoBlob(dataURL, 'screenshot');
      FORM_BODY.append('screen_shot', this.screenShotImage);
    } else {
      FORM_BODY.append('screen_shot', this.screenShotImage);
    }
    // Handle category selection (single or multiple based on nwc_client)
    if (this.observationForm.value.categories) {
      if (this.nwc_client) {
        // Single selection
        FORM_BODY.append('categories[]', this.observationForm.value.categories);
      } else {
        // Multiple selection
        this.observationForm.value.categories.forEach((categoryId: number) => {
          FORM_BODY.append('categories[]', categoryId.toString());
        });
      }
    }
    // Handle child category selection (single or multiple based on nwc_client)
    if (this.observationForm.value.child_categories) {
      if (this.nwc_client) {
        // Single selection
        FORM_BODY.append('subcategories[]', this.observationForm.value.child_categories);
      } else {
        // Multiple selection
        this.observationForm.value.child_categories.forEach((categoryId: number) => {
          FORM_BODY.append('subcategories[]', categoryId.toString());
        });
      }
    }
    this.observationForm.value.users?.map((user: any) => FORM_BODY.append('users[]', user));
    FORM_BODY.append('observation_flag', 'observation_on_360');
    FORM_BODY.append('due_date', this.formattedDate);

    this.attachments.map((file) => FORM_BODY.append('attached[]', file));

    FORM_BODY.append('is_draft', isDraft.toString());

    this.observationsService
      .createObservation(appendObservationHashtagsToFormData(FORM_BODY, this.observationHashtags))
      .subscribe(
        (res) => {
          this.globalService.showTopMsg(
            'success',
            this.translocoService.translate('Added Successfully'),
          );
          this.isLoading = false;
          this.dialogRef.close('added');
        },
        (error) => {
          error.error.errors.forEach((errorMessage: string) => {
            this._toaster.error(errorMessage);
          });
          this.isLoading = false;
        },
      );
  }

  getDescriptionCharCount(): number {
    if (!this.isComponentReady()) {
      return 0;
    }

    if (this.isEditorReady(this.descriptionEditor)) {
      try {
        const currentContent = this.descriptionEditor.getText();
        // Remove any trailing newline character that Quill adds
        const textContent = currentContent.replace(/\n$/, '').trim();
        return Math.min(textContent.length, this.maxQuillEditorsLength);
      } catch (error) {
        console.warn('Error getting description editor content:', error);
        // Fallback to form value if editor fails
        const description = this.observationForm.get('description')?.value || '';
        const textContent = description.replace(/<[^>]*>/g, '').trim();
        return Math.min(textContent.length, this.maxQuillEditorsLength);
      }
    }

    // Fallback to form value when editor is not ready
    const description = this.observationForm.get('description')?.value || '';
    // Remove HTML tags and get actual text length
    const textContent = description.replace(/<[^>]*>/g, '').trim();
    return Math.min(textContent.length, this.maxQuillEditorsLength);
  }

  getRecommendedActionCharCount(): number {
    if (!this.isComponentReady()) {
      return 0;
    }

    if (this.isEditorReady(this.recommendedActionEditor)) {
      try {
        const currentContent = this.recommendedActionEditor.getText();
        // Remove any trailing newline character that Quill adds
        const textContent = currentContent.replace(/\n$/, '').trim();
        return Math.min(textContent.length, this.maxQuillEditorsLength);
      } catch (error) {
        console.warn('Error getting recommended action editor content:', error);
        // Fallback to form value if editor fails
        const recommendedAction =
          this.observationForm.get('recommended_corrective_action')?.value || '';
        const textContent = recommendedAction.replace(/<[^>]*>/g, '').trim();
        return Math.min(textContent.length, this.maxQuillEditorsLength);
      }
    }

    // Fallback to form value when editor is not ready
    const recommendedAction =
      this.observationForm.get('recommended_corrective_action')?.value || '';
    // Remove HTML tags and get actual text length
    const textContent = recommendedAction.replace(/<[^>]*>/g, '').trim();
    return Math.min(textContent.length, this.maxQuillEditorsLength);
  }

  ngOnDestroy(): void {
    this.viewerMode.addObservationMode = false;
  }

  async getObservationSignificancesAndTypes(): Promise<void> {
    try {
      const res: any = await this.observationsService
        .observationSignificancesAndTypes()
        .toPromise();

      // Filter observation types based on NWC client status
      this.observationTypes = res?.data?.observation_types || [];

      this.observationSignificances = res?.data?.observation_significance || [];
      this.observationCodes = res?.data?.observation_code?.sort((a, b) => a.order - b.order) || [];

      // Store configurable fields from API response
      this.configurableFields = res?.data?.configurable_fields || [];

      // Remove hidden fields from form after getting configurable_fields
      this.removeHiddenFieldsFromForm();

      const defaultType =
        this.observationTypes.find((item) => item.order === 1) || this.observationTypes[0];
      if (defaultType && this.observationForm.get('type')) {
        this.observationForm.get('type').setValue(defaultType.value || null);
        this.setupCustomFields();
        this.getObservationCategories();
      } else {
        console.warn('No default observation type found with order === 1');
      }
      const defaultSignificance = this.observationSignificances.find((item) => item.order === 0);
      if (defaultSignificance && this.observationForm.get('significance')) {
        this.observationForm.get('significance').setValue(defaultSignificance.value || null);
      }
    } catch (error) {
      console.error('Error fetching observation significances and types:', error);
    }
  }

  openConfirmationDialog() {
    const dialogData = new ConfirmDialogModel(
      this.translocoService.translate('Warning'),
      this.translocoService.translate(`You have unsaved changes. What would you like to do?`),
      false,
      false,
      null,
      this.translocoService.translate('Save Draft'),
      this.translocoService.translate('Cancel'),
      '',
      false,
      [],
      this.translocoService.translate('Keep Editing'),
      !(this.observationForm.value.title && this.observationForm.value.type),
      'heroicons_solid:exclamation',
    );

    const confirmDialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(
      ConfirmDialogComponent,
      {
        maxWidth: '640px',
        minWidth: '300px',
        data: dialogData,
        disableClose: true,
      },
    );

    confirmDialog.afterClosed().subscribe((result) => {
      if (result) {
        result === true ? this.onSubmit(true) : null;
      } else {
        this.dialogRef.close(false);
      }
    });
  }

  isArabic() {
    let currentLang = localStorage.getItem('lang');
    return currentLang === 'ar';
  }

  onEditorCreated(quill: Quill, editorType?: 'description' | 'recommendedAction') {
    // Ensure quill is properly initialized
    if (!quill || typeof quill.getText !== 'function') {
      console.warn('Quill editor not properly initialized:', quill);
      return;
    }

    // Store the editor reference based on type first
    if (editorType === 'description') {
      this.descriptionEditor = quill;
      console.log('Description editor initialized:', quill);
    } else if (editorType === 'recommendedAction') {
      this.recommendedActionEditor = quill;
      console.log('Recommended action editor initialized:', quill);
    }

    quill.blur();
    if (this.isArabic()) {
      quill.format('font', 'mirza');
      quill.format('align', 'right');
      quill.format('direction', 'rtl');
    }

    quill.root.addEventListener('paste', (e: ClipboardEvent) => {
      console.log('DOM paste event triggered');
      const currentLength = quill.getText().trim().length;

      if (currentLength >= this.maxQuillEditorsLength) {
        console.log('DOM paste: preventing paste - already at limit');
        e.preventDefault();
        return;
      }

      if (e.clipboardData) {
        const pastedText = e.clipboardData.getData('text/plain');
        const pastedLength = pastedText.length;

        if (currentLength + pastedLength > this.maxQuillEditorsLength) {
          // Don't prevent default - let the paste happen, then truncate
          // We'll handle the truncation in the text-change event
          this.shouldTruncateAfterPaste = true;
          this.pendingTruncationLength = this.maxQuillEditorsLength;
        }
      }
    });

    quill.on('text-change', (delta, oldDelta, source) => {
      const text = quill.getText().trim();

      if (this.shouldTruncateAfterPaste && source === 'user') {
        if (text.length > this.pendingTruncationLength) {
          quill.deleteText(this.pendingTruncationLength, text.length);
        }
        this.shouldTruncateAfterPaste = false;
        this.pendingTruncationLength = 0;
      }

      // Handle regular truncation for other cases
      else if (text.length >= this.maxQuillEditorsLength && source === 'user') {
        quill.deleteText(this.maxQuillEditorsLength, text.length);
      }
    });
  }
}
